import { z } from "zod";

export function createEducationSchema(diplomaSatisfied: boolean, transcriptSatisfied: boolean) {
  return z
    .object({
      degree: z.string().min(1, { message: "validation.education.degree_required" }),
      university_name: z.string().min(1, { message: "validation.education.university_required" }),
      specialty: z.string().min(1, { message: "validation.education.specialty_required" }),
      admission_year: z.string().min(1, { message: "validation.education.admission_year_required" }),
      graduation_year: z.string(),
      diploma_number: z.string(),
      is_incomplete: z.boolean(),
      left_from_course: z.string(),
      diploma_file: z.instanceof(File).nullable(),
      diploma_transcript_file: z.instanceof(File).nullable(),
    })
    .superRefine(function refineEducation(data, ctx) {
      if (data.is_incomplete) {
        if (data.left_from_course.trim() === "") {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "validation.education.left_from_course_required",
            path: ["left_from_course"],
          });
        }
        return;
      }
      if (data.graduation_year.trim() === "") {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "validation.education.graduation_year_required",
          path: ["graduation_year"],
        });
      }
      if (data.diploma_number.trim() === "") {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "validation.education.diploma_number_required",
          path: ["diploma_number"],
        });
      }
      if (!data.diploma_file && !diplomaSatisfied) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "validation.education.file_required",
          path: ["diploma_file"],
        });
      }
      if (!data.diploma_transcript_file && !transcriptSatisfied) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "validation.education.transcript_required",
          path: ["diploma_transcript_file"],
        });
      }
    });
}

export type EducationFormValues = z.infer<ReturnType<typeof createEducationSchema>>;
